import React from "react";
import { CommonModal } from "../../../AbstractElements";
import { Button } from "reactstrap";

const OfferModal = ({ isOpen, onClose }) => (
  <CommonModal isOpen={isOpen} title="Offer Available" toggler={onClose}>
    <div className="text-center p-3">
      <h5 className="mb-3" style={{ color: 'black' }}>
        Congrats. You have won an offer for this trip
      </h5>
      <h5 className="mb-3" style={{ color: 'black' }}>
        Complete the trip to avail the offer
      </h5>
      <Button color="primary" onClick={onClose}>
        Okay
      </Button>
    </div>
  </CommonModal>
);

export default OfferModal;
